/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { ProductName } from '@atlassian/jira-shared-types/src/product-name.tsx';
import { useApplicationPermissions } from '../application-permissions/index.tsx';
import { getProductName } from './utils.tsx';

/**
 * Returns the product name based on application permissions.
 *
 * @agent-skills: tenant-context
 */
export const useProductName = (): ProductName => {
	const appPermissions = useApplicationPermissions();
	return getProductName(appPermissions);
};
